var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',_vm._l((_vm.model),function(item,index){return _c('div',{key:Math.random()+index,staticClass:"border p-50 mb-50"},[_c('form-generator',{attrs:{"schema":_vm.schema,"model":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }